var _path, _rect, _path2, _rect2, _path3, _rect3, _rect4, _g, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 522,
    viewBox: "0 0 435 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.425 0L435 115H38V0H322.425Z",
    fill: "#FAFAFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 115,
    width: 397,
    height: 407,
    fill: "#FAFAFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.5 115H435L322.5 0V115Z",
    fill: "#DEE2E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 115,
    width: 97,
    height: 16,
    fill: "#E9ECEF",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.323 123C135.027 172.113 170.627 224.708 214.5 279.291C275.856 355.627 338.19 411.736 396 452.359V459.791C396 477.464 381.673 491.791 364 491.791H110C92.3269 491.791 78 477.464 78 459.791V154.791C78 138.361 90.3819 124.824 106.323 123Z",
    fill: "#E9ECEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 278,
    height: 111,
    fill: "#D63384"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 131,
    width: 218,
    height: 31,
    fill: "#E9ECEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_106_947)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.7358 60.375C87.4176 57.3977 86.0767 55.0795 83.7131 53.4205C81.3722 51.7614 78.3267 50.9318 74.5767 50.9318C71.9403 50.9318 69.679 51.3295 67.7926 52.125C65.9063 52.9205 64.4631 54 63.4631 55.3636C62.4631 56.7273 61.9517 58.2841 61.929 60.0341C61.929 61.4886 62.2585 62.75 62.9176 63.8182C63.5994 64.8864 64.5199 65.7955 65.679 66.5455C66.8381 67.2727 68.1222 67.8864 69.5312 68.3864C70.9403 68.8864 72.3608 69.3068 73.7926 69.6477L80.3381 71.2841C82.9744 71.8977 85.5085 72.7273 87.9403 73.7727C90.3949 74.8182 92.5881 76.1364 94.5199 77.7273C96.4744 79.3182 98.0199 81.2386 99.1562 83.4886C100.293 85.7386 100.861 88.375 100.861 91.3977C100.861 95.4886 99.8153 99.0909 97.7244 102.205C95.6335 105.295 92.6108 107.716 88.6562 109.466C84.7244 111.193 79.9631 112.057 74.3722 112.057C68.9403 112.057 64.2244 111.216 60.2244 109.534C56.2472 107.852 53.1335 105.398 50.8835 102.17C48.6563 98.9432 47.4517 95.0114 47.2699 90.375H59.7131C59.8949 92.8068 60.6449 94.8295 61.9631 96.4432C63.2813 98.0568 64.9972 99.2614 67.1108 100.057C69.2472 100.852 71.6335 101.25 74.2699 101.25C77.0199 101.25 79.429 100.841 81.4972 100.023C83.5881 99.1818 85.2244 98.0227 86.4062 96.5455C87.5881 95.0455 88.1903 93.2955 88.2131 91.2955C88.1903 89.4773 87.6563 87.9773 86.6108 86.7955C85.5653 85.5909 84.0994 84.5909 82.2131 83.7955C80.3494 82.9773 78.1676 82.25 75.6676 81.6136L67.7244 79.5682C61.9744 78.0909 57.429 75.8523 54.0881 72.8523C50.7699 69.8295 49.1108 65.8182 49.1108 60.8182C49.1108 56.7045 50.2244 53.1023 52.4517 50.0114C54.7017 46.9205 57.7585 44.5227 61.6222 42.8182C65.4858 41.0909 69.8608 40.2273 74.7472 40.2273C79.7017 40.2273 84.0426 41.0909 87.7699 42.8182C91.5199 44.5227 94.4631 46.8977 96.5994 49.9432C98.7358 52.9659 99.8381 56.4432 99.9062 60.375H87.7358ZM119.977 111H106.477L131.057 41.1818H146.67L171.284 111H157.784L139.136 55.5H138.591L119.977 111ZM120.42 83.625H157.239V93.7841H120.42V83.625ZM181.852 41.1818L200.023 96.1364H200.739L218.875 41.1818H232.784L208.17 111H192.557L167.977 41.1818H181.852Z",
    fill: "#FAFAFD"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M358.316 391.235C349.655 397.511 336.128 397.046 327.8 389.126C318.962 380.723 313.484 370.553 305.192 360.392C301.259 355.58 297.53 352.862 288.632 355.796C271.151 361.571 252.266 362.951 234.131 362.549C219.368 362.432 202.811 361.778 185.327 356.012C176.432 353.075 172.703 355.79 168.773 360.608C160.478 370.766 155.003 380.93 146.162 389.339C137.84 397.253 124.31 397.724 115.646 391.442C103.301 382.499 100.496 374.879 103.649 362.936C108.602 344.165 118.232 306.545 123.011 287.726C132.515 250.31 141.083 244.214 174.662 242.57C182.423 242.192 192.56 242.141 199.019 252.65C201.875 257.3 206.717 256.556 211.256 256.547H262.706C267.248 256.556 272.081 257.09 274.946 252.44C281.399 241.931 291.533 241.976 299.297 242.357C332.876 244.004 341.486 250.085 350.951 287.516C357.29 312.608 363.119 336.143 370.313 362.723C373.544 374.651 370.664 382.289 358.316 391.235ZM195.476 294.764H181.982V281.27C181.982 277.298 178.76 274.076 174.788 274.076H169.193C165.218 274.076 161.999 277.298 161.999 281.27V294.764H148.505C144.533 294.764 141.311 297.983 141.311 301.958V307.553C141.311 311.525 144.533 314.747 148.505 314.747H161.999V328.244C161.999 332.216 165.221 335.432 169.193 335.432H174.788C178.76 335.432 181.982 332.216 181.982 328.244V314.747H195.476C199.448 314.747 202.667 311.525 202.667 307.553V301.961C202.667 297.986 199.448 294.764 195.476 294.764ZM296.678 273.74C289.217 273.74 283.16 279.794 283.16 287.258C283.16 294.719 289.217 300.77 296.678 300.77C304.142 300.77 310.199 294.719 310.199 287.258C310.196 279.794 304.142 273.74 296.678 273.74ZM276.998 307.562C269.54 307.562 263.486 313.613 263.486 321.074C263.486 328.538 269.54 334.592 276.998 334.592C284.462 334.592 290.516 328.538 290.516 321.074C290.516 313.613 284.462 307.562 276.998 307.562ZM316.358 307.562C308.888 307.562 302.846 313.613 302.846 321.074C302.846 328.538 308.888 334.592 316.358 334.592C323.822 334.592 329.87 328.538 329.87 321.074C329.87 313.613 323.822 307.562 316.358 307.562Z",
    fill: "#D63384"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_106_947",
    x: 35.2695,
    y: 40.2266,
    width: 201.516,
    height: 87.832,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_947"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_106_947",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSav);
export default __webpack_public_path__ + "static/media/sav.5e9e5c0274d8e70558d2cbe685b8f21d.svg";
export { ForwardRef as ReactComponent };